import dayjs from "dayjs";
import { useEffect, useRef, useState } from "react";
import {
  archive_btn,
  copyLessons_loaderGif,
  course_demo_image,
  delete_alert_popup,
  duplicate_course_btn,
  unarchive_btn,
  warning_blue_img,
} from "../../../../../../assets/images/images";
import DescriptionCoursePopup from "./DescriptionCoursePopup";
import { useDispatch, useSelector } from "react-redux";
import {
  setpublishtoSchoologydtls,
  resetPublishtoSchoology,
} from "../../../../../../state/actions/publishtoSchoologyAction";
import { useAuth } from "../../../../../../features/auth/AuthContext";
import { toast } from "react-toastify";
import {
  syncCourseToGoogleDrive,
  resetgoogleDriveCourseSync,
} from "../../../../../../state/actions/googleDriveCourseSyncAction";
import { Ring } from "@uiball/loaders";
import UploadFileBtn from "../../../../../../components/FileRepo/Components/Buttons/UploadFileBtn";
import { useModal } from "../../../../../../components/FileRepo/hooks/useModal";
import ProfileModal from "../../../../../../components/FileRepo/FileActions/ProfileModal";
// import GoogleDriveConnect from "./GoogleDriveConnect";
import MenuItem from "@mui/material/MenuItem";
import MuiTooltip from "@mui/material/Tooltip";
import StyledMenu from "../../../../../../components/StyleMenu";
import RemovePopup from "../../../../../../components/RemovePopup/RemovePopup";
import api from "../../../../../../api/api";
import { useNavigate } from "react-router";
import CopyLessonsModal from "../../../../../../components/CopyLessonsModal/CopyLessonsModal";
import { duplicateLessonsApi } from "../../../../../../components/CopyLessonsModal/utils/apiHelper";
import { Tooltip } from "react-tooltip";
import { getAllCoursesByTeacherId } from "../../../../../../state/actions/getAllCoursesByTeacherIdAction";
import { updateGlobalState } from "../../../../../../state/global/slice";
import Loader from "../../../../../../components/FileRepo/Components/Loader";
import "./CourseDetailsHeader.css";

const CourseDetailsHeader = ({
  course,
  onEditCourseClick,
  toggleinvite,
  totalLessons,
  totalAssignments,
  totalStudent,
  Sales_Courses_title,
  checkbox,
  setactiveTabCourse,
  onInvitedStudents,
  refetchCourse,
  updateCourseArchiveStatus,
  // disableCourseFilesBtn = false
}) => {
  const { modal, reqData, openModal, closeModal } = useModal();
  const navigate = useNavigate();

  const [descriptionOpen, setDescriptionOpen] = useState(false);
  const [showViewMore, setShowViewMore] = useState(false);
  const [openDuplicateModal, setOpenDuplicateModal] = useState(false)
  const paragraphRef = useRef(null);
  const { token } = useAuth();
  const dispatch = useDispatch();
  const globalState = useSelector((state) => state.globalState);
  const { message, isLoading, error } = useSelector(
    (state) => state.publishtoSchoology,
  );
  const googleDriveCourseSync = useSelector(
    (state) => state.googleDriveCourseSync,
  );
  const updateState = (key, value) => {
    dispatch(updateGlobalState({ key: key, value: value }));
  };
  const currency_symbol = useSelector((state) => state?.globalState?.currency_symbol);
  const [isSaveChecker, setisSaveChecker] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingPopUp, setLoadingPopUp] = useState(false);
  const [showPopUp, setShowPopUp] = useState(false);
  const [isShowGoogleUploadPopup, setIsShowGoogleUploadPopup] = useState(false);
  const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);
  const openFileuploadPopup = () => {
    setIsShowGoogleUploadPopup(true);
  };

  // Local state for edit/delete dropdown
  const [anchorEl, setAnchorEl] = useState(null);
  const [activeMenuCourseId, setActiveMenuCourseId] = useState(null);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [archiveCourse, setArchiveCourse] = useState(false);
  const [archiveLoading, setArchiveLoading] = useState(false);
  const [archiveAction, setArchiveAction] = useState({ courseId: null, isArchived: false });
  const [isDuplicatingCourse, setIsDuplicatingCourse] = useState(false)
  const teacher_id = globalState?.teacher_details?.data?.teacher_id;
  const handleMenuIconClick = (event, courseId) => {
    setAnchorEl(event.currentTarget);
    setActiveMenuCourseId(courseId);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleOpenDeletePopup = () => {
    setIsDeletePopupOpen(true);
    handleMenuClose();
  };
  const handleClose = () => {
    setAnchorEl(null);
    setActiveMenuCourseId(null);
  };
  const handleCloseDeletePopup = () => {
    setIsDeletePopupOpen(false);
  };
  const toggleArchiveCourse = (courseId = null, isArchived = false) => {
    setArchiveAction({ courseId, isArchived });
    setArchiveCourse(prev => !prev);
    setArchiveLoading(false);
    document.body.style.overflow = "auto";
  }


  const handleArchiveCourse = async () => {
    const { courseId, isArchived } = archiveAction;
    if (!courseId) return;
    setArchiveLoading(true);
    document.body.style.overflow = "auto";
    try {
      const response = await api.post(
        `/courses/${courseId}/archive/`,
        { is_archived: !isArchived },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
          },
        }
      );
      if (response.status === 200) {
        setArchiveLoading(false);
        const course_list = globalState.course_list?.map((course) =>
          course.course_id === courseId
            ? { ...course, is_archived: !isArchived }
            : course,
        );
        updateState("course_list", course_list);
        dispatch(getAllCoursesByTeacherId("1", teacher_id, token));

        updateCourseArchiveStatus(!isArchived);
        toast.success(
          <div>
            <div className="font-bold">
              {isArchived
                ? "Course Restored Successfully"
                : "Course Archived Successfully"}
            </div>

            <div className="mt-1">
              {isArchived ? (
                <>
                  “{selectedCourse}” has been moved back to Active Courses
                </>
              ) : (
                <>
                  You can access the archived course, “{selectedCourse},”
                  from the Total Courses → Archive tab.
                </>
              )}
            </div>
          </div>,
          {
            containerId: "archive-toast",
          },
        );
        setTimeout(() => {
          setArchiveCourse(false);
        }, 700);
      } else {
        setArchiveLoading(false);
        setArchiveCourse(false);
        toast.error("Something went wrong. Please Try Again", {
          position: "top-center",
        });
      }
    } catch (error) {
      setArchiveLoading(false);
      setArchiveCourse(false);
      toast.error("Something went wrong.", {
        position: "top-center",
      });
    }
  };

  const deleteCourseFromDetails = async () => {
    try {
      const response = await api.delete(`/courses/delete-course/${course?.course_id}/`, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Token ${token}`,
        },
      });

      if (response.status === 200) {
        toast.success("Course deleted successfully.", {
          position: "top-center",
        });
        setIsDeletePopupOpen(false);
        navigate("/");
      } else {
        toast.error("Something went wrong.", {
          position: "top-center",
        });
      }
    } catch (error) {
      toast.error("Something went wrong.", {
        position: "top-center",
      });
    }
  };

  const descriptionToggle = () => {
    document.body.style.overflow = descriptionOpen ? "auto" : "hidden";
    setDescriptionOpen(!descriptionOpen);
  };
  // const onCoursePublishToSchoology = () => {
  //   setisSaveChecker(true);
  //   const req = {
  //     course_id: course?.course_id,
  //   };
  //   dispatch(setpublishtoSchoologydtls(req, token));
  // };

  const handleCreateCourseInSchoology = async () => {
    setLoadingPopUp(true); // Start loader
    setisSaveChecker(true); // Disable the button
    try {
      const req = {
        course_id: course?.course_id,
        create_new_course: true,
      };

      // Dispatch the Redux action and wait for its completion
      await dispatch(setpublishtoSchoologydtls(req, token));
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setLoadingPopUp(false); // Stop loader
      setisSaveChecker(false); // Re-enable the button
    }
  };

  const onCoursePublishToSchoology = async () => {
    setLoading(true); // Start loader
    setisSaveChecker(true); // Disable the button
    try {
      const req = {
        course_id: course?.course_id,
        // create_new_course:true
      };
      // Dispatch the Redux action and wait for its completion
      await dispatch(setpublishtoSchoologydtls(req, token));
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setLoading(false); // Stop loader
      setisSaveChecker(false); // Re-enable the button
    }
  };

  useEffect(() => {
    const descriptionLength = course?.description?.length || 0;

    // Show "View More" if description is longer than 150 characters
    // This is a more reasonable threshold for showing the button
    const shouldShowViewMore = descriptionLength > 285;
    setShowViewMore(shouldShowViewMore);
  }, [course?.description]);

  useEffect(() => {
    const failedErrorMessage =
      "Oops, something went wrong. Please try again later.";

    if (message) {
      toast.success(message, {
        position: "top-center",
      });
      setisSaveChecker(false);

      setShowPopUp(false);
    } else if (error) {
      if (error === "User not found on Schoology. Unable to sync course.") {
        toast.error(error || failedErrorMessage, {
          position: "top-center",
        });
      }

      if (
        error ===
        "User not found on Schoology. Hence, unable to sync course 'Quadratic Equations'."
      ) {
        toast.error(error || failedErrorMessage, {
          position: "top-center",
        });
      }
      if (error === "Unable to Sync Course: Course Not Found on Schoology") {
        setShowPopUp(true);
      } else {
        dispatch(resetPublishtoSchoology());
        setisSaveChecker(false);
      }
    } else {
      setisSaveChecker(false);
    }
    return () => {
      dispatch(resetPublishtoSchoology());
      setisSaveChecker(false);
    };
  }, [message, error]);

  useEffect(() => {
    return () => {
      dispatch(resetPublishtoSchoology());
    };
  }, []);

  const syncCoursetoDrive = () => {
    const req = {
      course_id: course?.course_id,
    };
    dispatch(syncCourseToGoogleDrive(req, token));
  };

  useEffect(() => {
    if (googleDriveCourseSync?.message) {
      toast.success(
        "Uploading is in progress; We will notify you once it is completed.",
        {
          position: "top-center",
        },
      );
    }
    if (googleDriveCourseSync?.error) {
      toast.error("Please connect to your Google Drive", {
        position: "top-center",
      });
    }

    return () => {
      dispatch(resetgoogleDriveCourseSync());
    };
  }, [googleDriveCourseSync]);

  const handleDuplicateLessonsSubmit = async (payload) => {
    try {
      updateState("isDuplicatingCourse", true);

      await duplicateLessonsApi(payload, token);

      toast.success(`Course ${course.name} duplicated successfully`);
      navigate("/");
    } catch (error) {

      const errorMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        "Failed to duplicate course";

      toast.error(errorMessage);
    } finally {
      updateState("isDuplicatingCourse", false);
    }
  };
  return (
    <div className="view-course-details-container teacher-course-header">
      <div className="view-course-details-folder">
        <div className="view-course-details-left-section">
            <div className="view-course-details-image">
          {course?.image ? (
              <img src={course?.image} alt="Course Image" />
          ) : (
            <img src={course_demo_image} alt="Course Image" />
          )}
            </div>
        </div>
        <div className="view-course-details-right-section">
          {/* <div className="view-course-details-edit-and-share-container"> */}
          {course?.is_archived && (
            <p className="text-[#555555] font-light text-sm md:text-lg text-right w-fit flex-nowrap cursor-default border border-[#DEDEDE] bg-[#FAFAFA] rounded-lg px-2 mb-2 md:mb-0 ">
              Archived{" "}
              <img
                className="h-3 w-3 md:h-4 md:w-4 mb-1"
                src={unarchive_btn}
                alt="unarchive_btn"
              />
            </p>
          )}
          <div className="flex flex-col sm:flex-row justify-center mb-2 gap-x-4 gap-y-2 flex-wrap sm:justify-end md:justify-start lg:justify-end" >
            {/* {onEditCourseClick && globalState.role !== "SuperAdmin" && course?.my_role !== "viewer" && (
              <button
                onClick={onEditCourseClick}
                type="button"
                className="view-course-details-edit-and-share-folder"
              >
                <span>
                  <i className="fa-solid fa-pencil"></i>
                </span>
                <p>Edit</p>
              </button>
            )} */}

            <div className="flex flex-wrap gap-3 w-full flex-1 sm:w-auto sm:flex-none">
              {course?.my_role !== "viewer" &&
                globalState.role === "Teacher" && (
                  <>
                    {/* Tooltip anchors on the wrapper: a disabled button doesn't fire hover events. */}
                    <MuiTooltip
                      // title={
                      //   disableCourseFilesBtn
                      //     ? "Lower School courses does not support file uploads"
                      //     : ""
                      // }
                      placement="top"
                      arrow
                    >
                      <div className="flex flex-1 sm:flex-none sm:w-auto">
                        <UploadFileBtn
                          className="w-full"
                          handleClick={() => {
                            openModal("uploadFile", course);
                          }}
                          label={
                            course?.aggregated_file_count
                              ? `Course Files (${course.aggregated_file_count})`
                              : "Course Files"
                          }
                          // disabled={disableCourseFilesBtn}
                        />
                      </div>
                    </MuiTooltip>
                    {modal === "uploadFile" && (
                      <ProfileModal
                        open={modal === "uploadFile"}
                        close={closeModal}
                        course={reqData}
                        type={'course'}
                        id={course.course_id}
                        onUploadComplete={refetchCourse}
                      />
                    )}
                  </>
                )}

              <button
                onClick={onInvitedStudents}
                type="button"
                className="Invited_students_btn sm:w-auto  flex-1 sm:flex-none"
              >
                <p>Invited students</p>
              </button>
            </div>
            <div className="flex items-center gap-2 flex-nowrap overflow-x-auto whitespace-nowrap shrink-0">
              {((toggleinvite && course?.my_role !== "viewer" && !course.is_archived)) && (
                <div
                  className="view-course-details-edit-and-share-folder view-course-details-share-btn sm:w-auto"
                  onClick={toggleinvite}
                >
                  <span>
                    <i className="fa-solid fa-user-plus"></i>
                  </span>
                  <p>Invite Students</p>
                </div>
              )}
              {globalState.enabled_modules?.includes("year2year") &&
                course?.my_role !== "viewer" && !course.is_archived && (
                  <button
                    className="bg-[#FAFAFA] border border-[#DEDEDE] rounded-lg px-3 h-[39px] shrink-0 flex items-center justify-center"
                    onClick={() => setOpenDuplicateModal(true)}
                    data-tooltip-id="duplicate-button"
                  >
                    <img
                      className="h-4 w-4"
                      src={duplicate_course_btn}
                      alt="duplicate button"
                    />
                  </button>
                )}
              <Tooltip
                id="duplicate-button"
                place="bottom"
                content="Duplicate Course"
              />
              {course?.my_role !== "viewer" && (
                <div className="edit-course-dropdown-menu-container">
                  <div
                    className="edit-course-or-delete-course shrink-0"
                    style={{ cursor: "pointer" }}
                    onClick={(e) => handleMenuIconClick(e, course.course_id)}
                  >
                    <i className="fa-solid fa-ellipsis-vertical"></i>
                  </div>
                  <StyledMenu
                    id="course-actions-menu"
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleMenuClose}
                  >
                    {!course.is_archived && (<MenuItem
                      onClick={() => {
                        if (
                          onEditCourseClick &&
                          globalState.role !== "SuperAdmin"
                        ) {
                          onEditCourseClick();
                        }
                        handleMenuClose();
                      }}
                      disableRipple
                      sx={{
                        backgroundColor: "transparent !important",
                        "&.Mui-focusVisible": {
                          backgroundColor: "transparent",
                        },
                        "&:hover": {
                          backgroundColor: "#f5f5f5",
                        },
                      }}
                    >
                      <button
                        type="button"
                        className="course-edit-or-delete-folder"
                      >
                        <a href="#">
                          <i className="fa-solid fa-pencil"></i>
                        </a>
                        <p>Edit Course</p>
                      </button>
                    </MenuItem>)}
                    {(course.my_role === "owner" ||
                      globalState.role === "Admin") &&
                      globalState.enabled_modules?.includes("year2year") && (
                        <MenuItem
                          onClick={() => {
                            if (activeMenuCourseId === course.course_id) {
                              setSelectedCourse(course.name); // optional for toast
                              toggleArchiveCourse(
                                course.course_id,
                                course.is_archived,
                              );
                            }
                            handleClose();
                          }}
                          disableRipple
                        >
                          <button
                            type="button"
                            className="course-edit-or-delete-folder"
                          >
                            <img
                              className="h-4 w-4"
                              src={archive_btn}
                              alt="archive_btn"
                            />
                            <p>
                              {course.is_archived ? "Unarchive" : "Archive"}{" "}
                              Course
                            </p>
                          </button>
                        </MenuItem>
                      )}
                    {((course?.my_role === "owner" && !course.is_archived)) && (
                      <MenuItem
                        onClick={handleOpenDeletePopup}
                        disableRipple
                        sx={{
                          backgroundColor: "transparent !important",
                          "&.Mui-focusVisible": {
                            backgroundColor: "transparent",
                          },
                          "&:hover": {
                            backgroundColor: "#f5f5f5",
                          },
                        }}
                      >
                        <button
                          type="button"
                          className="course-edit-or-delete-folder"
                        >
                          <a href="#">
                            <i className="fa-solid fa-trash"></i>
                          </a>
                          <p>Delete Course</p>
                        </button>
                      </MenuItem>
                    )}
                  </StyledMenu>
                </div>
              )}
            </div>
          </div>

          <div className="created-my-courses-title-wrapper">
            <h2 className="py-1">{course?.name}</h2>

            {globalState.enabled_modules?.includes('marketplace') && (
              <div className="studentDashboar-Suggested-Courses-profile-rate !flex-row">
                <a> <i className="fa-solid fa-star"></i> </a>
                <p className="rate">{course?.average_course_rating || "0"}</p>
                <p className="number">({parseInt(course?.rating_count || 0)})</p>
              </div>
            )}
          </div>
          <div
            className="teacherviewcoursedetails-des-wrapper"
            style={{ position: "relative" }}
          >
            <p
              className="teacherviewcoursedetails-des"
              ref={paragraphRef}
              style={{
                overflow: showViewMore ? "hidden" : "visible",
                position: "relative",
              }}
            >
              {course?.description}
            </p>
            {showViewMore && (
              <span className="view-more" onClick={descriptionToggle}>
                View More
              </span>
            )}
            {descriptionOpen && (
              <DescriptionCoursePopup
                title="My Course Description"
                data={course?.description}
                onClick={descriptionToggle}
              />
            )}
          </div>
          <div className="view-course-details-container justify-start lg:gap-[32px]">
            <div className="view-Students-course-details-folder">
              <span>Total Lessons</span>
              <div
                className="view-Students-course-details-counts cursor-pointer"
                onClick={() => setactiveTabCourse("lessons")}
              >
                <p>{totalLessons}</p>
                <p>{totalLessons > 1 ? "Lessons" : "Lesson"} </p>
              </div>
            </div>
            <div className="view-Students-course-details-folder">
              <span>
                {" "}
                {totalAssignments > 1
                  ? "Total Assignments"
                  : "Total Assignment"}{" "}
              </span>
              <div
                className="view-Students-course-details-counts cursor-pointer"
                onClick={() => setactiveTabCourse("lessons")}
              >
                {/* <p>{course?.total_assignments}</p> */}
                <p>{totalAssignments}</p>
                <p>{totalAssignments > 1 ? "Assignments" : "Assignment"} </p>
              </div>
            </div>
            <div className="view-Students-course-details-folder">
              <span>Students Enrolled</span>
              <div
                className="view-Students-course-details-counts cursor-pointer"
                onClick={() => setactiveTabCourse("students")}
              >
                <p>{totalStudent}</p>
                <p> {totalStudent > 1 ? "Students" : "Student"}</p>
              </div>
            </div>
            <div className="view-Students-course-details-folder">
              <span>Course Start Date</span>
              <div className="view-Students-course-details-counts">
                <p>{dayjs(course?.start_date).format("MMM DD, YYYY")} </p>
              </div>
            </div>
            <div className="view-Students-course-details-folder">
              <span>Course Expiry Date:</span>
              <div className="view-Students-course-details-counts">
                <p>
                  {course?.end_date !== null && course?.end_date !== ""
                    ? dayjs(course?.end_date).format("MMM DD, YYYY")
                    : "- -"}
                </p>
              </div>
            </div>
            {/* Marketplace: Total Revenue display */}
            {globalState.enabled_modules?.includes("marketplace") &&
              course?.price !== null &&
              course?.total_revenue !== null && course.my_role === "owner" &&
              (
                <div className="Students-courses-details-folder">
                  <span>Total Revenue</span>
                  <div className="view-Students-course-details-counts">
                    <p>
                      {course.total_revenue !== null &&
                        course.total_revenue !== "" && (
                          <p>
                            {course?.currency_symbol ?? currency_symbol}{" "}
                            {course.total_revenue}
                          </p>
                        )}
                    </p>
                  </div>
                </div>
              )}
          </div>
          {/* <GoogleDriveConnect/> */}
        </div>
      </div>

      {/* {
        showPopUp && <CancelPopup title={'course not found in schoology, do you you want to create course in schoology'} No={'No'} Yes={'Yes'} show={handleCreateCourseInSchoology} close={() => { setShowPopUp(false) }} loading={loading} />
      } */}
      {showPopUp && (
        <>
          <form action="" className="Course-created-successfully-form">
            <div
              className="schoology-Course-created-successfully-container"
              data-aos="zoom-in"
            >
              <h2>
                Course unavailable on Schoology. Would you like to create it?
              </h2>
              {/* { loadingPopUp ? <h2> Please wait...</h2> : <h2>Course unavailable on Schoology. Would you like to create it?</h2> } */}
              <div className="schoology-Course-created-successfully-container-btn-folder">
                {loadingPopUp ? (
                  // <div className="loading-spinner" />
                  <Ring />
                ) : (
                  <>
                    <button
                      type="button"
                      onClick={handleCreateCourseInSchoology}
                      className="create-btn"
                    >
                      Yes
                    </button>

                    <button
                      type="button"
                      onClick={() => setShowPopUp(false)}
                      disabled={loadingPopUp}
                    >
                      No
                    </button>
                  </>
                )}
              </div>
            </div>
          </form>
        </>
      )}

      {isDeletePopupOpen && (
        <RemovePopup
          title="Are you sure you want to delete this course?"
          cancel="No"
          submit="Delete"
          onclick={deleteCourseFromDetails}
          onClose={handleCloseDeletePopup}
          image={delete_alert_popup}
        />
      )}
      {openDuplicateModal && (
        <CopyLessonsModal
          course={course}
          open={openDuplicateModal}
          onClose={() => setOpenDuplicateModal(false)}
          onSubmit={handleDuplicateLessonsSubmit}
          mode="duplicate"
          courseId={course?.course_id}
          setIsDuplicatingCourse={setIsDuplicatingCourse}
        />
      )}
      {isDuplicatingCourse && (
        <div className="fixed inset-0 z-[999999] flex items-center justify-center  px-4">
          <div className="bg-white rounded-2xl shadow-xl w-full max-w-[320px] min-h-[220px] flex flex-col items-center justify-center p-6">
            <div className="w-[100px] h-[60px] flex items-center justify-center">
              <img
                src={copyLessons_loaderGif}
                alt="transferring"
                className="w-full h-full object-contain"
              />
            </div>

            <p className="mt-5 text-[16px] sm:text-[18px] font-semibold text-[#2B2B2B] text-center leading-[24px]">
              Duplicating Your Course.
              <span className="font-normal"> This may take a moment...</span>
            </p>
          </div>
        </div>
      )}
      {archiveCourse && (
        <form action="" className="delete-course-form">
          <div
            className="delete-course-form-container relative"
            data-aos="zoom-in"
          >
            {archiveLoading && (
              <div className="absolute inset-0 z-50 flex items-center justify-center bg-white rounded-xl">
                <Loader />
              </div>
            )}

            <div className="delete-course-alert-image">
              <img src={warning_blue_img} alt="" />
            </div>

            <h2>
              Are you sure you want to{" "}
              {archiveAction.isArchived ? "unarchive" : "archive"} this course?
            </h2>

            <div className="delete-course-form-btn-folder">
              <button
                type="button"
                onClick={() => toggleArchiveCourse()}
                disabled={archiveLoading}
                className="border-[#0068FF] bg-white text-[#0068FF]"
              >
                No
              </button>

              <button
                type="button"
                onClick={handleArchiveCourse}
                disabled={archiveLoading}
                className="border-[#0068FF] text-white bg-[#0068FF]"
              >
                {archiveAction.isArchived ? "Unarchive" : "Archive"}
              </button>
            </div>
          </div>
        </form>
      )}
    </div>
  );
};

export default CourseDetailsHeader;